import React, { useEffect, useState } from "react";
import { SlovHeader } from "./cardsHeader";

export const CardsFinalPickScreen = (props) => {
    useEffect(() => {
        props.CBcolor("#777777");
    }, []);

    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const [selectedPic, setSelectedPic] = useState(null);

    const players = [
        { index: 1, name: props.TextString },
        { index: 2, name: props.TextString2 },
        { index: 3, name: props.TextString3 },
        { index: 4, name: props.TextString4 },
        { index: 5, name: props.TextString5 },
        { index: 6, name: props.TextString6 },
        { index: 7, name: props.TextString7 },
        { index: 8, name: props.TextString8 },
    ].filter((player) => player.name !== undefined && player.name !== "None");

    const pics = [
        { index: 1, text: props.TextString9 },
        { index: 2, text: props.TextString10 },
        { index: 3, text: props.TextString11 },
    ];

    const blockStyle = {
        width: "90%",
        margin: "0 auto 15px auto",
        padding: "10px",
        border: "1px solid #999",
        borderRadius: "8px",
        backgroundColor: "rgba(255, 255, 255, 0.4)",
        color: "black",
    };

    const picButtonStyle = {
        width: "90%",
        padding: "12px",
        marginBottom: "10px",
        fontSize: "16px",
    };

    const canConfirm = selectedPlayer !== null && selectedPic !== null;

    return (
        <div id="game">
            <SlovHeader />

            <img
                src={props.PColors !== undefined ? "https://cyberbox.trgu.ru/public/avatars/cards/PlayerMain" + (props.PColors + 1) + ".png" : "Аватар загружается\n"}
                alt="Player Avatar"
            />
            <br />
            <div className="divtext_slov"><b>{props.prName}</b></div>
            <br />
            <div className="divtext_slov"><b>{props.slovGamePoints}</b> очков</div>
            <br />

            <div className="divtext_slov"><b>Выберите игрока:</b></div>
            <br />

            <div style={blockStyle}>
                {players.map((player) => (
                    <label key={player.index} style={{ display: "block", marginBottom: "10px" }}>
                        <input
                            type="radio"
                            name="player"
                            checked={selectedPlayer === player.index}
                            onChange={() => setSelectedPlayer(player.index)}
                        />
                        {" "}
                        {player.name}
                    </label>
                ))}
            </div>

            <div className="divtext_slov"><b>Выберите картинку по описанию:</b></div>
            <br />

            {pics.map((pic) => (
                <React.Fragment key={pic.index}>
                    <button
                        type="button"
                        style={{
                            ...picButtonStyle,
                            fontWeight: selectedPic === pic.index ? "bold" : "normal",
                            border: selectedPic === pic.index ? "3px solid black" : undefined,
                        }}
                        onClick={() => setSelectedPic(pic.index)}
                    >
                        {pic.text}
                    </button>
                    <br />
                </React.Fragment>
            ))}

            <button
                type="button"
                disabled={!canConfirm}
                onClick={() => {
                    props.sendMessage(`sendtoserver|slov\\buttonchosen\\playerandpic\\${selectedPlayer}\\${selectedPic}`);
                }}
            >
                Подтвердить
            </button>
        </div>
    );
};